<div class="row">
    <div class="col-md-9">
        <button class="btn btn-primary d-md-none d-lg-none"
                (click)="openFacet()">
            Filter Results
        </button>
        <h3 *ngIf="isLoading && !searchResults" [innerHTML]="loadingMessage" class="py-2"></h3>
        <h3 *ngIf="searchResults && searchResults.TotalMatching>0" [innerHTML]="searchResults.ResultFoundMessage" class="py-2"></h3>
        <h3 *ngIf="searchResults && searchResults.TotalMatching==0" [innerHTML]="searchResults.NoResultMessage" class="py-2"></h3>
    </div>
    <div class="col-md-3" *ngIf="searchResults && searchResults.SortByOptions?.length>0">
        <label class="input-group d-flex align-items-center">
            <span class="input-group-prepend text-primary pr-2">
                {{searchResults.SortByLabel}}
            </span>
            <select required class="form-control d-inline-block" (change)="sortChange($event)">
                <option *ngFor="let sortOption of searchResults.SortByOptions" value={{sortOption.Value}} [selected]="sortOption.Selected === true">
                    {{sortOption.Text}}
                </option>
            </select>
        </label>
    </div>
</div>
<div *ngFor="let s of sizes" class="{{s.css + ' ' + (prefix + s.id) }}"></div>

<div *ngIf="searchResults?.RelatedQueries?.Hits.length > 0" id="related-queries">
    <p>People also searched for :</p>
    <span *ngFor="let q of searchResults?.RelatedQueries.Hits; let last = last">
        <a [href]="origin + '/search/?q=' + encodeQuery(q.Suggestion)"
           target="_blank"
           rel="noopener noreferrer">
            {{ q.Suggestion | titlecase }}
        </a><span *ngIf="!last">, </span>
    </span>
</div>

<div class="row">
    <div class="col-lg-3 col-md-4 d-none d-md-block d-lg-block p-3" #facet>
        <div class="p-3 mb-5" [ngClass]="{'bg-light': searchResults && searchResults.ContentTypesFilterFacets?.length>0}">
            <div class="py-2" *ngIf="searchResults && searchResults.ContentTypesFilterFacets?.length>0">
                <h5>Date</h5>
                <div class="form-check" *ngFor="let dateRange of searchResults.DateRangeFacets">
                    <input class="form-check-input"
                           type="radio"
                           name="date"
                           id="{{dateRange.DisplayName}}"
                           (change)="toggleCheck($event,dateRange)"
                           [checked]="dateRange.checked"
                           value="{{dateRange.DisplayName}}" />
                    <label class="form-check-label" for="{{dateRange.DisplayName}}">
                        {{dateRange.DisplayName}}
                    </label>
                </div>
                <div class="p-1">
                    <label class="form-check-label w-25">From:</label>
                    <input type="text" class="datepicker" name="StartDate" [disabled]="true" data-date-format="mm-dd-yyyy" datepicker (change)="onCalenderchange($event)" #fromDate />
                </div>
                <div class="p-1">
                    <label class="form-check-label w-25">To:</label>
                    <input type="text" class="datepicker" name="EndDate" [disabled]="true" data-date-format="mm-dd-yyyy" datepicker (change)="onCalenderchange($event)" #toDate />
                </div>
                <div class="text-secondary pt-3" *ngIf="!isValidDate">
                    {{dateErrorMessage}}
                </div>
            </div>
            <div class="py-2" *ngIf="searchResults && searchResults.ContentTypesFilterFacets?.length>0">
                <h5>Content Type</h5>
                <div class="form-check" *ngFor="let contentType of searchResults.ContentTypesFilterFacets">
                    <input class="form-check-input"
                           type="checkbox"
                           name="contentType"
                           value="{{contentType.Value}}"
                           (change)="toggleCheck($event,contentType)"
                           [checked]="contentType.checked"
                           id="{{contentType.Name}}" />
                    <label class="form-check-label" for="{{contentType.Name}}">
                        {{contentType.Name}}
                    </label>
                </div>
            </div>
            <div class="py-2" *ngIf="searchResults && searchResults.AuthorsTermFacets?.length>0">
                <h5>Author</h5>
                <div class="form-check" *ngFor="let author of searchResults.AuthorsTermFacets | slice:0:4">
                    <input class="form-check-input"
                           type="checkbox"
                           name="author"
                           value="{{author.Value}}"
                           (change)="toggleCheck($event,author)"
                           [checked]="author.checked"
                           id="{{author.Name}}" />
                    <label class="form-check-label" for="author">
                        {{author.Description}}
                    </label>
                </div>
                <div id="accordion-author" [attr.class]="authorExpanded?'collapse show':'collapse'" #accordion_author>
                    <div class="form-check" *ngFor="let author of searchResults.AuthorsTermFacets | slice:startAuthorSliceValue:endAuthorSliceValue">
                        <input class="form-check-input"
                               type="checkbox"
                               value="{{author.Value}}"
                               name="author"
                               (change)="toggleCheck($event,author)"
                               [checked]="author.checked"
                               id="{{author.Name}}" />
                        <label class="form-check-label" for="author">
                            {{author.Description}}
                        </label>
                    </div>
                </div>
                <a *ngIf="searchResults.AuthorsTermFacets?.length > 4" href="#accordion-author"
                   [attr.aria-expanded]="authorExpanded?true:false"
                   (click)="ExapandCollapse($event)"
                   id="author"
                   title="Click Here">
                    <span class="collapse-label-close" #showMoreAuthorLink>{{showMore}}</span>
                </a>
            </div>
            <div class="py-2" *ngIf="searchResults && searchResults.CategoriesTermFacets?.length>0">
                <h5>Category</h5>
                <div class="form-check" *ngFor="let category of searchResults.CategoriesTermFacets | slice:0:4">
                    <input class="form-check-input"
                           type="checkbox"
                           name="category"
                           value="{{category.Value}}"
                           (change)="toggleCheck($event,category)"
                           [checked]="category.checked"
                           id="{{category.Name}}" />
                    <label class="form-check-label" for="category">
                        {{category.Description}} ({{category.Count}})
                    </label>
                </div>
                <div id="accordion-category" [attr.class]="categoryExpanded?'collapse show':'collapse'" #accordion_category>
                    <div class="form-check" *ngFor="let category of searchResults.CategoriesTermFacets | slice:startcategorySliceValue:endcategorySliceValue">
                        <input class="form-check-input"
                               type="checkbox"
                               value="{{category.Value}}"
                               name="category"
                               (change)="toggleCheck($event,category)"
                               [checked]="category.checked"
                               id="{{category.Name}}" />
                        <label class="form-check-label" for="category">
                            {{category.Description}} ({{category.Count}})
                        </label>
                    </div>
                </div>
                <a *ngIf="searchResults.CategoriesTermFacets?.length > 4" href="#accordion-category"
                   [attr.aria-expanded]="categoryExpanded?true:false"
                   (click)="ExapandCollapse($event)"
                   id="category"
                   title="Click Here">
                    <span class="collapse-label-close" #showMorecategoryLink>{{showMore}}</span>
                </a>
            </div>
            <button class="btn btn-primary d-md-none d-lg-none"
                    (click)="closeFacet()">
                Apply Filters
            </button>
        </div>
    </div>

    <div class="col-lg-9 col-md-8 col-12 swapa-body" *ngIf="searchResults" [ngStyle]="{'min-height': searchResults.Items.length==0 ?'350px':'0px'}">
        <article class="row" *ngFor="let article of searchResults.Items">
            <div class="col-12 col-md-4 mb-2 mb-md-0">
                <img class="cover"
                     src="{{article.ImageUrl}}"
                     alt=""
                     width="100%"
                     height="200" />
            </div>
            <div class="col-12 col-md-8">
                <a href="{{article.Url}}" [attr.target]="article.IsMedia ? '_blank' : '_self'">
                    <h3 [innerHTML]="article.Title" class="text-break">
                    </h3>
                </a>
                <a>{{article.Date}}</a>
                <span *ngIf="(article.AuthorsTags && article.AuthorsTags.length>0) || (article.Tags && article.Tags.length>0) || article.ArticleTypeTagText"> | </span>
                <ng-container *ngIf="article.ArticleTypeTagText">
                    <a href="?articleType={{article.ArticleType}}">{{article.ArticleTypeTagText}}</a><span *ngIf="(article.AuthorsTags && article.AuthorsTags.length>0) || (article.Tags && article.Tags.length>0)">, </span>
                </ng-container>
                <ng-container *ngFor="let authorTag of article.AuthorsTags; let first = first; let last = last;">
                    <a href="?authorTag={{authorTag.ID}}">{{authorTag.Description}}</a><span *ngIf="!last">, </span>
                </ng-container>
                <span *ngIf="article.AuthorsTags && article.AuthorsTags.length>0 && article.Tags && article.Tags.length>0">, </span>
                <ng-container *ngFor="let tag of article.Tags; let first = first; let last = last;">
                    <a href="?tag={{tag.UrlFriendlyName}}">{{tag.Name}}</a><span *ngIf="!last">, </span>
                </ng-container>
                <p [innerHTML]="article.Summary">
                </p>
            </div>
        </article>
    </div>

</div>

<!-- pagination -->
<div *ngIf="searchResults && searchResults.Items?.length>0 && searchResults.TotalMatching > pageSize" class="row justify-content-center justify-content-md-between align-items-center">
    <div class="col-12 col-md-5 text-left">
        <span>Showing {{endIndex}} of {{ searchResults.TotalMatching }} results</span>
    </div>
    <div class="col-12 col-md-5 text-center">
        <ngb-pagination [collectionSize]="searchResults.TotalMatching" [(page)]="page" [pageSize]="pageSize" [maxSize]="3" [rotate]="true" [boundaryLinks]="false" (pageChange)="onChangePage($event)" aria-label="Default pagination">
        </ngb-pagination>
    </div>
    <div class="col-12 col-md-2 text-right">
        <p *ngIf="isLoading">Please wait...</p>
    </div>
</div>

<div *ngIf="searchResults && searchResults.Items?.length>0" class="swapa-top-tocshortcut text-right text-nonselectable">
    <a class="anchor-scroll btn btn-sm btn-primary ml-auto p-1 mb-2" href="#topofbody"> ↑ Back To Top </a>
</div>
